import { IFormWrapper } from "./form-wrapper.types";

export const FormWrapper: IFormWrapper = ({ title, children, titleInfo }) => {
  return (
    <div className="form-wrapper relative w-[calc(100%+40px)] left-[-20px] md:w-[calc(100%+80px)] md:left-[-40px] form-wrapper px-[20px] md:px-[40px] py-[40px] md:py-[60px] bg-form-bg flex flex-row items-start justify-between gap-[32px] flex-wrap">
      <div className="form-title flex flex-col gap-[32px] md:gap-[40px] items-start">
        <h4 className="text-[32px] md:text-[60px] font-[600] uppercase leading-[90%]">{title}</h4>
        {titleInfo}
      </div>
      {children}
    </div>
  );
};
